import { render } from "./vbatchmanageinfo.vue?vue&type=template&id=066b8520&scoped=true"
import script from "./vbatchmanageinfo.vue?vue&type=script&lang=js"
export * from "./vbatchmanageinfo.vue?vue&type=script&lang=js"

import "./vbatchmanageinfo.vue?vue&type=style&index=0&id=066b8520&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066b8520"]])

export default __exports__